import React, { useEffect } from 'react';
import './App.css';
import Chat from './components/Chat';
import Sidebar from './components/Sidebar';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from './components/Login';
import { useStateValue } from './StateProvider';
import { auth } from './firebase';
import { actionTypes } from './reducer';

function App() {

  const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    //this will run once when the app component loads...

    auth.onAuthStateChanged(authUser => {
      console.log('The user is >>> ', authUser);

      if (authUser) {
        //the user just loggedin / the user was loggedin
        dispatch({
          type: actionTypes.SET_USER,
          user: authUser
        })
      } else {
        //the user is logged Out
        dispatch({
          type: actionTypes.SET_USER,
          user: null
        })
      }
    })
  }, [])


  return (
    <div className="app">
      {!user ? (
        <Login />

      ) : (
          <div className="app__body">
            <Router>
              <Sidebar />
              <Switch>
                <Route path="/rooms/:roomId">
                  <Chat />
                </Route>
                <Route path="/">
                  <Chat />
                </Route>
              </Switch>
            </Router>
          </div>
        )}
    </div>
  );
}

export default App;
